import { FormControl } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ToolCategoryIcon = styled.i`
  ${({ theme }) => css`
    color: ${theme.colors.blue[800]};
    font-size: ${theme.fontSizes[600]};
  `}
`;
export const FormControlStyled = styled(FormControl)`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.blue[800]};
    border-radius: ${theme.spacings[200]};
    flexgrow: 1;
    width: 100%;
  `}
`;
